import React from 'react';

function Services() {
  const services = [
    {
      title: 'Aquatic Vegetation Management',
      description: 'Management of beneficial and nuisance aquatic vegetation to maintain a healthy, balanced ecosystem.',
      icon: '🌿',
    },
    {
      title: 'Fountain & Aerator Service',
      description: 'Installation, maintenance, and repairs for fountains and aerators to keep your water features running beautifully.',
      icon: '⛲',
    },
    {
      title: 'Algae & Vegetation Control',
      description: 'Control and removal of algae, muck, and other unwanted vegetation to restore water clarity and health.',
      icon: '🧪',
    },
    {
      title: 'Water Quality Testing',
      description: 'Comprehensive water quality testing to identify issues and develop effective treatment plans.',
      icon: '🔬',
    },
    {
      title: 'Storm Water Drainage',
      description: 'Storm water drainage maintenance to ensure proper water flow and prevent flooding issues.',
      icon: '🌊',
    },
    {
      title: 'Custom Projects',
      description: 'No project is too big or too small. Contact us to discuss your needs.',
      icon: '🤝',
    },
  ];

  return (
    <section id="services" className="bg-white py-8 md:py-12">
      <div className="container mx-auto px-4">
        <h2 className="text-3xl md:text-4xl font-bold text-brand-900 text-center mb-4">
          Our Services
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
          {services.map((service, index) => (
            <div
              key={index}
              className="bg-slate-50 rounded-lg p-6 shadow-md border-2 border-brand-100 hover:border-water-400 hover:shadow-lg transition-all duration-200"
            >
              <div className="text-4xl mb-4">{service.icon}</div>
              <h3 className="text-xl font-bold text-brand-900 mb-2">
                {service.title}
              </h3>
              <p className="text-slate-600 leading-relaxed">
                {service.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA */}
        <div className="text-center mt-12">
          <p className="text-lg text-brand-700 mb-4">
            Need help with your pond or lake?
          </p>
          <a
            href="tel:+17272773366"
            className="inline-block bg-water-600 hover:bg-water-700 text-white font-bold py-3 px-8 rounded-lg transition-colors duration-200 min-h-[48px]"
          >
            Call Joe for a Free Consultation
          </a>
        </div>
      </div>
    </section>
  );
}

export default Services;
